import { Component, h, Prop, Element } from '@stencil/core';
import { createRouter, Route } from 'stencil-router-v2';
import { _BREAKPOINTS_ } from 'utils';
import axios from 'axios';

const Router = createRouter();

@Component({
  tag: 'dev-siteloader',
  shadow: false
})
export class SiteLoader {

  @Element() root: HTMLElement;

  @Prop() markup: any;

  componentDidRender() {
    return this.fetchContents();
  }

  componentWillUpdate() {
    return this.fetchContents();
  }

  fetchContents() {
    const path = document.location.pathname;

    if (this.root.querySelector('.page-root')) {
      this.root.querySelector('.page-root').setAttribute('drawn', 'false');
    }

    axios.get(`/pages${path}/index.html`)
      .then((response) => {
        this.markup = response.data;
        if (this.root.querySelector('.page-root')) {
          this.root.querySelector('.page-root').setAttribute('drawn', 'true');
          globalThis.init_tables();
          globalThis.imageLoader?.initialize();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
  
  render() {
    return (
      <Router.Switch>
        <Route 
          path={document.location.pathname}
          render={() => (
            <div class="page-root" innerHTML={this.markup} />
          )}
        />
      </Router.Switch>
    )
  }
}